/**
 * Public Navbar Configuration
 * Centralizes all navbar behavior settings for mobile scroll interactions
 */

export const navbarConfig = Object.freeze({
  /**
   * Height of the mobile navbar in Chakra units (1 unit = 4px)
   * Used for layout spacing and positioning calculations
   */
  NAVBAR_HEIGHT_MOBILE: 12,

  /**
   * Height of the desktop navbar in Chakra units.
   * Keeps public and private shell offsets aligned on md+ screens.
   */
  NAVBAR_HEIGHT_DESKTOP: 16,

  /**
   * Lock navbar visibility on mobile (disable hide on scroll behavior)
   * When true, navbar remains visible regardless of scroll
   */
  NAVBAR_LOCK: false,

  /**
   * Minimum scroll distance to consider (ignores micro-scrolls)
   * Prevents navbar from reacting to tiny scroll movements
   */
  NAVBAR_SCROLL_THRESHOLD_PX: 20,

  /**
   * Velocity threshold in pixels per millisecond (0.3-1.0 range)
   * Lower values make navbar hide more easily on slow scrolls
   * Higher values require faster scrolling to trigger hide
   */
  NAVBAR_VELOCITY_THRESHOLD: 0.9,

  /**
   * Delay before hiding navbar on fast scroll down (in milliseconds)
   * Provides brief window to reverse scroll direction before hiding
   */
  NAVBAR_HIDE_DELAY_MS: 150,

  /**
   * Transition duration for hide/show animations (in seconds)
   * Controls smoothness of navbar appearance/disappearance
   */
  NAVBAR_HIDE_TRANSITION_SEC: 0.5,

  /**
   * Exponential moving average factor for velocity smoothing (0.5-0.8 range)
   * Higher values = smoother velocity calculations, less responsive to sudden changes
   * Lower values = more responsive to immediate scroll changes
   */
  VELOCITY_SMOOTHING: 0.5,
} as const);

export type NavbarConfig = typeof navbarConfig;
